import api from '.'

export const siteMonitoringIssues = {
  create (monitoringId, data, success, fail) {
    api.authenticatedRequest('POST', `/site-monitoring/${monitoringId}/site-issues`, data, success, fail)
  },
  getForMonitoring (monitoringId, success, fail) {
    api.authenticatedRequest('GET', `/site-monitoring/${monitoringId}/site-issues`, null, success, fail)
  },
  update (issueId, data, success, fail) {
    api.authenticatedRequest('PUT', `/site-issues/${issueId}`, data, success, fail)
  },
  delete (issueId, success, fail) {
    api.authenticatedRequest('DELETE', `/site-issues/${issueId}`, null, success, fail)
  }
}
